import React from 'react';
// import "../../assets/css/master.css";

import TemplateDashboard from "../../../components/TemplateDashboard";
import AsignacionMasivaContent from './components/AsignacionMasivaContent';
import AlertNotificaciones from '../../../components/AlertNotificaciones/AlertNotificaciones';

const AsignacionMasiva = () => {

    return (
        <>

            <TemplateDashboard>
                <AsignacionMasivaContent />
            </TemplateDashboard>

        </>
    )
};

export default AsignacionMasiva;